import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import AdminIndex from "../admin/pages/Index";
import HelpPage from "../admin/pages/help/HelpPage";
import GroupHome from "./GroupHome";
import GroupConsoleMenu from "./GroupConsoleMenu";
import GroupStudents from "./pages/GroupStudents";
import GroupInstructors from "./pages/GroupInstructors";
import GroupParents from "./pages/GroupParents";
import GroupAdmins from "./pages/GroupAdmins";
import GroupAdmissions from "./pages/GroupAdmissions";
import GroupFeeStats from "./pages/GroupFeeStats";
import GroupExpenses from "./pages/GroupExpenses";
import GroupStock from "./pages/GroupStock";
import GroupWakeupAlarms from "./pages/GroupWakeupAlarms";
import GroupSchedule from "./pages/GroupSchedule";
import GroupJuniorCourseBoard from "./pages/GroupJuniorCourseBoard";
import GroupSeniorCourseBoard from "./pages/GroupSeniorCourseBoard";

const GroupConsoleRoutes = () => (
  <Routes>
    <Route path="group/home" element={<GroupHome />} />
    <Route path="group/profile" element={<AdminIndex />} />
    <Route path="group/help" element={<HelpPage />} />
    <Route path="group/menu" element={<GroupConsoleMenu />} />
    <Route path="group/menu/students" element={<GroupStudents />} />
    <Route path="group/menu/instructors" element={<GroupInstructors />} />
    <Route path="group/menu/parents" element={<GroupParents />} />
    <Route path="group/menu/admins" element={<GroupAdmins />} />
    <Route path="group/menu/admissions" element={<GroupAdmissions />} />
    <Route path="group/menu/fee" element={<GroupFeeStats />} />
    <Route path="group/menu/expenses" element={<GroupExpenses />} />
    <Route path="group/menu/stock" element={<GroupStock />} />
    <Route path="group/menu/alarm" element={<GroupWakeupAlarms />} />
    <Route path="group/menu/schedule" element={<GroupSchedule />} />
    <Route
      path="group/menu/course-board/junior"
      element={<GroupJuniorCourseBoard />}
    />
    <Route
      path="group/menu/course-board/senior"
      element={<GroupSeniorCourseBoard />}
    />
    <Route
      path="group"
      element={<Navigate to="/dashboard/group/home" replace />}
    />
    <Route
      index
      element={<Navigate to="/dashboard/group/home" replace />}
    />
  </Routes>
);

export default GroupConsoleRoutes;
